// @ts-nocheck
import { useTranslation } from 'react-i18next'

export default function PageLoader() {
  const { t } = useTranslation()
  return (
    <div className="page-loader" role="status" aria-live="polite">
      {t('common.loading')}
    </div>
  )
}
